const MEDIA_SELECTOR =
  'img, picture, svg, video, audio, iframe, embed, object, hr'

const checkEmptyElement = (el: Element) =>
  !el.textContent?.replace(/\s+/g, '') &&
  !el.matches(MEDIA_SELECTOR) &&
  !el.querySelector(MEDIA_SELECTOR)

const checkIgnorableNode = (node: Node) =>
  node.nodeType !== Node.ELEMENT_NODE &&
  (node.nodeType !== Node.TEXT_NODE || !node.nodeValue?.trim())

const findMeaningfulNode = (
  node: Node | null,
  direction: 'previousSibling' | 'nextSibling'
) => {
  let currentNode = node

  while (currentNode && checkIgnorableNode(currentNode)) {
    currentNode = currentNode[direction]
  }

  return currentNode
}

const checkEmptyNode = (node: Node | null) =>
  node instanceof Element && checkEmptyElement(node)

const trimElementEdges = (el: Element) => {
  el.innerHTML = el.innerHTML
    .replace(/(\s*<br>\s*){2,}/g, '<br>')
    .replace(/^(<br>|&nbsp;)+|(<br>|&nbsp;)+$/g, '')
}

const collapseLineBreaks = (html: string) =>
  html.replace(/[ \t\f]*\n[ \t\f\n]*/g, '\n')

const normalizeHTML = <V extends string | null | undefined>(value: V) => {
  if (typeof value !== 'string') {
    return value
  }

  if (!value.trim()) {
    return ''
  }

  const { body: htmlContainer } = new DOMParser().parseFromString(
    collapseLineBreaks(
      value
        .replace(/\r\n?/g, '\n')
        .replace(/(&nbsp;)+/g, ' ')
        .replace(/[ \t\f]+/g, ' ')
    ).trim(),
    'text/html'
  )

  const childEls = Array.from(htmlContainer.children)

  childEls.forEach(trimElementEdges)

  childEls.forEach((childEl) => {
    if (!checkEmptyElement(childEl)) {
      return
    }

    const prevNode = findMeaningfulNode(
      childEl.previousSibling,
      'previousSibling'
    )

    if (!prevNode || checkEmptyNode(prevNode)) {
      childEl.remove()
    }
  })

  let lastNode = findMeaningfulNode(htmlContainer.lastChild, 'previousSibling')

  while (lastNode && checkEmptyNode(lastNode)) {
    const prevNode = lastNode.previousSibling

    htmlContainer.removeChild(lastNode)
    lastNode = findMeaningfulNode(prevNode, 'previousSibling')
  }

  return collapseLineBreaks(htmlContainer.innerHTML).trim()
}

export default normalizeHTML
